@if (isInputBased) {
	<mat-form-field>
		<mat-label>{{ label }}</mat-label>
		<input
			matInput
			[matDatepicker]="picker"
			[formControl]="formControl"
			(dateChange)="onDateChange($event)"
			[class.error]="outDated()"
			[placeholder]="'enter_year_placeholder' | translate"
			[max]="disableFutureDates() && now()"
		/>
		<mat-datepicker-toggle
			matIconSuffix
			class="accent-icon mat-input-suffix"
			[for]="picker"
		/>
		<mat-datepicker #picker panelClass="au-mat-calendar" />
	</mat-form-field>
} @else {
	<div class="cmms-date-picker">
		@if (label) {
			<span class="select-label">{{ label }}</span>
		}
		@if (date) {
			<span
				[ngClass]="outDated() ? 'calendar-date expired' : 'calendar-date'"
				[matMenuTriggerFor]="menu"
			>
				{{ date | date: 'longDate' }}
			</span>
		} @else {
			<p class="no-date-select" [matMenuTriggerFor]="menu">{{ placeholderText }}</p>
		}
	</div>
}

<mat-menu #menu="matMenu" class="calendar-menu">
	<mat-calendar
		[minDate]="minDate"
		[maxDate]="disableFutureDates() && now()"
		(click)="$event.stopPropagation()"
		[selected]="convertIntoDateForMatCalendar(date)"
		(selectedChange)="selectedChange($event)"
		class="au-mat-calendar"
	/>
</mat-menu>
